import { SITE_MEDIA_DEFAULTS } from "../content/siteMediaDefaults";

export const SITE_MEDIA_PLACEMENTS = {
  hero: {
    label: { en: "Homepage Hero Background", id: "Latar Hero Homepage" },
    page: { en: "Homepage", id: "Beranda" },
    section: { en: "Full-width hero behind headline & CTAs", id: "Hero penuh di belakang judul & CTA" },
    description: {
      en: "The full-width image behind “Mahjong Anywhere. Anytime.” and its booking buttons.",
      id: "Gambar penuh di belakang “Mahjong Anywhere. Anytime.” dan tombol bookingnya.",
    },
    purpose: {
      en: "Use a clear, high-contrast Mahjong scene with quiet space for the headline on the left.",
      id: "Gunakan suasana Mahjong kontras tinggi dengan ruang tenang untuk judul di sisi kiri.",
    },
    dimensions: "Desktop 1600 × 1000 px · 16:10 | Mobile 1080 × 1350 px · 4:5",
    cropNote: {
      en: "Responsive cover cropping may occur, especially on mobile. Keep important subjects centred.",
      id: "Crop cover responsif dapat terjadi, terutama di mobile. Letakkan subjek penting di tengah.",
    },
    accepted: "JPG, PNG, WEBP, GIF · max. 5 MB",
    viewUrl: "/#homepage-hero",
    variant: "hero",
    fallbackImage: SITE_MEDIA_DEFAULTS.hero,
  },
  banner: {
    label: { en: "Homepage Banner Slider", id: "Slider Banner Beranda" },
    page: { en: "Homepage", id: "Beranda" },
    section: { en: "Promotion banner below hero", id: "Banner promo di bawah hero" },
    description: {
      en: "Appears in the horizontal slider after the homepage hero. Multiple images rotate here.",
      id: "Muncul pada slider horizontal setelah hero beranda. Beberapa gambar bergantian di sini.",
    },
    purpose: {
      en: "Use time-sensitive promotions, event announcements, or package highlights.",
      id: "Gunakan untuk promo terbatas, pengumuman acara, atau paket unggulan.",
    },
    dimensions: "1600 × 700 px · 21:9",
    accepted: "JPG, PNG, WEBP, GIF · max. 5 MB",
    viewUrl: "/#homepage-banners",
    variant: "banner",
  },
  tiles: {
    label: { en: "Homepage How It Works Image", id: "Foto Cara Kerja Beranda" },
    page: { en: "Homepage", id: "Beranda" },
    section: { en: "How It Works illustration", id: "Ilustrasi bagian Cara Kerja" },
    description: {
      en: "Appears next to the seven How It Works steps on desktop.",
      id: "Muncul di samping tujuh langkah Cara Kerja pada desktop.",
    },
    purpose: {
      en: "Use a close, legible image of Mahjong tiles or the portable table.",
      id: "Gunakan foto tile Mahjong atau meja portabel yang dekat dan mudah terlihat.",
    },
    dimensions: "1200 × 900 px · 4:3",
    accepted: "JPG, PNG, WEBP, GIF · max. 5 MB",
    viewUrl: "/#homepage-how-it-works",
    variant: "tiles",
  },
  gallery: {
    label: { en: "Homepage Customer Gallery", id: "Galeri Pelanggan Beranda" },
    page: { en: "Homepage", id: "Beranda" },
    section: { en: "Customer Moments gallery", id: "Galeri Momen Pelanggan" },
    description: {
      en: "Appears in the tiled customer photo gallery near the bottom of the homepage.",
      id: "Muncul di galeri foto pelanggan berbentuk grid di bagian bawah beranda.",
    },
    purpose: {
      en: "Use real event or gameplay photos that show the product in use.",
      id: "Gunakan foto acara atau permainan nyata yang memperlihatkan produk sedang dipakai.",
    },
    dimensions: "1200 × 900 px · 4:3",
    accepted: "JPG, PNG, WEBP, GIF · max. 5 MB",
    viewUrl: "/#homepage-gallery",
    variant: "gallery",
  },
};

export const SITE_MEDIA_COPY = {
  en: {
    title: "Banners & Photos",
    intro: "Manage website imagery and review each image placement before uploading.",
    placementPreview: "Placement Preview",
    currentImages: "Active image",
    currentDefault: "Current built-in default",
    noActiveImage: "No active image. The website is using its built-in fallback where available.",
    page: "Page",
    section: "Section",
    recommendedUse: "Recommended use",
    recommendedSize: "Recommended size",
    acceptedFiles: "Accepted files",
    viewOnPage: "View on Page",
    multiple: "Multiple images rotate in this slider.",
    single: "One image. A new upload replaces the current image.",
    upload: "Upload",
    uploaded: "Image uploaded",
    uploadFailed: "Upload failed",
    deleteConfirm: "Delete this image?",
    deleted: "Deleted",
    titleId: "Title in Indonesian (optional)",
    subtitleId: "Subtitle in Indonesian (optional)",
    linkUrl: "Link when clicked (optional)",
    order: "Order",
    titleEn: "Title in English (optional)",
    subtitleEn: "Subtitle in English (optional)",
    showFrom: "Show from",
    until: "until",
    alwaysLive: "Leave blank to show continuously.",
    visible: "Visible",
    hidden: "Hidden",
    remove: "Remove",
    noImages: "No uploaded image yet — the built-in image above is being used.",
    limit: "Maximum of {count} banners reached. Remove one before adding another.",
  },
  id: {
    title: "Banner & Foto",
    intro: "Kelola gambar website dan lihat lokasi tampil tiap gambar sebelum mengunggahnya.",
    placementPreview: "Preview Penempatan",
    currentImages: "Gambar aktif",
    currentDefault: "Gambar bawaan yang sedang tampil",
    noActiveImage: "Belum ada gambar aktif. Website memakai gambar bawaan jika tersedia.",
    page: "Halaman",
    section: "Bagian",
    recommendedUse: "Tujuan yang disarankan",
    recommendedSize: "Ukuran disarankan",
    acceptedFiles: "File yang diterima",
    viewOnPage: "Lihat di Halaman",
    multiple: "Beberapa gambar bergantian pada slider ini.",
    single: "Satu gambar. Upload baru menggantikan gambar saat ini.",
    upload: "Upload",
    uploaded: "Gambar diunggah",
    uploadFailed: "Upload gagal",
    deleteConfirm: "Hapus gambar ini?",
    deleted: "Dihapus",
    titleId: "Judul Indonesia (opsional)",
    subtitleId: "Subjudul Indonesia (opsional)",
    linkUrl: "Link saat diklik (opsional)",
    order: "Urutan",
    titleEn: "Judul English (opsional)",
    subtitleEn: "Subjudul English (opsional)",
    showFrom: "Tayang mulai",
    until: "sampai",
    alwaysLive: "Kosongkan bila mau tayang terus.",
    visible: "Tampil",
    hidden: "Disembunyikan",
    remove: "Hapus",
    noImages: "Belum ada gambar yang diunggah — gambar bawaan di atas sedang digunakan.",
    limit: "Sudah mencapai batas {count} banner. Hapus salah satu dulu untuk menambah yang baru.",
  },
};